import { render, staticRenderFns } from "./Aboutour.vue?vue&type=template&id=49535401&scoped=true&"
import script from "./Aboutour.vue?vue&type=script&lang=js&"
export * from "./Aboutour.vue?vue&type=script&lang=js&"
import style0 from "./Aboutour.vue?vue&type=style&index=0&id=49535401&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49535401",
  null
  
)

export default component.exports